import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { NotFoundPage } from '../../app/NotFoundPage';
import { useFeatureEnabled } from '../../tenant/useTenantSettings';

export function BlogGate() {
  const enabled = useFeatureEnabled('blogs');
  if (enabled === null) return <div className="page" aria-busy="true" />;
  if (!enabled) return <NotFoundPage />;
  return (
    <Suspense fallback={<div className="page" aria-busy="true" />}>
      <Outlet />
    </Suspense>
  );
}
